<section id="section-screen-view-directives" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Screen View Directives</p>

    <p class="m-t-20 m-b-0">
      The Screen View Directives works just like breakpoint classes of bootstrap, but instead of render a hidden element, it will not be
      rendered on screen.
    </p>

    <p class="m-t-4 m-b-0">
      <span class="ff-medium"> PS: </span>

      Resize the screen to see a hands on.
    </p>

    <p class="m-t-20 m-b-0">
      <span class="ff-medium"> limitUp: </span>

      Greater than or equals to the BreakPoint.
    </p>

    <p class="m-t-4 m-b-0">
      <span class="ff-medium"> smallerThan: </span>

      As the name... Smaller than BreakPoint.
    </p>

    <p class="h3 m-t-20">limitUp</p>

    <div class="limitUp">
      <div class="block">
        <p class="d-none d-sm-block">Displayed by class - Greater than or equal to: Mobile</p>
        <p *limitUp="DEVICE_SIZE.MOBILE">Displayed by Directive - Greater than or equal to: Mobile</p>
      </div>

      <div class="block">
        <p class="d-none d-md-block">Displayed by class - Greater than or equal to: Tablet</p>
        <p *limitUp="DEVICE_SIZE.TABLET">Displayed by Directive - Greater than or equal to: Tablet</p>
      </div>

      <div class="block">
        <p class="d-none d-lg-block">Displayed by class - Greater than or equal to: Desktop</p>
        <p *limitUp="DEVICE_SIZE.DESKTOP">Displayed by Directive - Greater than or equal to: Desktop</p>
      </div>

      <div class="block">
        <p class="d-none d-xl-block">Displayed by class - Greater than or equal to: Wide</p>
        <p *limitUp="DEVICE_SIZE.WIDESCREEN">Displayed by Directive - Greater than or equal to: Wide</p>
      </div>
    </div>

    <p class="h3 m-t-20">smallerThan</p>

    <div class="smallerThan">
      <div class="block">
        <p class="d-block d-sm-none">Displayed by class - Smaller than Mobile</p>
        <p *smallerThan="DEVICE_SIZE.MOBILE">Displayed by Directive - Smaller than Mobile</p>
      </div>

      <div class="block">
        <p class="d-block d-md-none">Displayed by class - Smaller than Tablet</p>
        <p *smallerThan="DEVICE_SIZE.TABLET">Displayed by Directive - Smaller than Tablet</p>
      </div>

      <div class="block">
        <p class="d-block d-lg-none">Displayed by class - Smaller than Desktop</p>
        <p *smallerThan="DEVICE_SIZE.DESKTOP">Displayed by Directive - Smaller than Desktop</p>
      </div>

      <div class="block">
        <p class="d-block d-xl-none">Displayed by class - Smaller than Wide</p>
        <p *smallerThan="DEVICE_SIZE.WIDESCREEN">Displayed by Directive - Smaller than Wide</p>
      </div>
    </div>
  </div>
</section>
